'use strict';

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} icon - icon that was clicked to add a product to the wishlist
 */
function changeIcon(addedToWishlist, currEle) {
    if (addedToWishlist) {
        currEle.find('.wishlist-icon-regular').removeClass('d-flex').addClass('d-none');
        currEle.find('.wishlist-icon-solid').addClass('d-flex').removeClass('d-none');
        currEle.addClass('selected');
    } else {
        currEle.find('.wishlist-icon-regular').addClass('d-flex').removeClass('d-none');
        currEle.find('.wishlist-icon-solid').removeClass('d-flex').addClass('d-none');
        currEle.removeClass('selected');
    }
}

module.exports = {
    addToWishlist: function () {
        $('body').on('click', '.wishlist-icon:not(.selected)', function (e) {
            e.preventDefault();
            const $this = $(this);
            var ele = $(this);
            var url = ele.data('addwishlist');
            var pid = ele.data('pid');
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid
                },
                success: function (data) {
                    changeIcon(true, ele);
                    if (!ele.hasClass(pid)) {
                        var productTileIcon = $('.wishlist-icon.' + pid);
                        changeIcon(true, productTileIcon);
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    if (!err.responseJSON.loggedin && err.responseJSON.loginUrl) {
                        $('body').trigger('signinModal:open', [err.responseJSON.loginUrl, pid]);
                        if($this.closest('.product-quickview').length) {
                            $('#quickViewModal .close').trigger('click');
                        }
                    }
                    $.spinner().stop();
                }
            });
        });
    },
    removeFromWishlist: function () {
        $('body').on('click', '.wishlist-icon.selected', function (e) {
            e.preventDefault();
            var ele = $(this);
            var url = ele.data('removewishlist');
            var pid = ele.data('pid');
            if (!url || !pid) {
                return;
            }

            var avoidAjax = $(ele).find('.avoid-ajax:visible');
            if (avoidAjax && $(e.target).hasClass('add-to-wishlist')) {
                window.location.href = $(avoidAjax).attr('href');
                return;
            }

            $.spinner().start();
            $.ajax({
                url: url + '?pid=' + pid,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    changeIcon(false, ele);
                    if (!ele.hasClass(pid)) {
                        var productTileIcon = $('.wishlist-icon.' + pid);
                        changeIcon(false, productTileIcon);
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    changeIcon(false, ele);
                    if (!ele.hasClass(pid)) {
                        var productTileIcon = $('.wishlist-icon.' + pid);
                        changeIcon(false, productTileIcon);
                    }
                    if (!err.responseJSON.loggedin && err.responseJSON.loginUrl) {
                        $('body').trigger('signinModal:open', err.responseJSON.loginUrl);
                    }
                    $.spinner().stop();
                }
            });
        });
    }

};
